import BidDetailIcon from "@/assets/images/Tab/bid-detail-icon.png";
import BidDetailIconActive from "@/assets/images/Tab/bid-detail-icon-active.png";
import BidEstimateIconActive from "@/assets/images/Tab/bid-estimate-icon-active.png";
import BidEstimateIcon from "@/assets/images/Tab/bid-estimate-icon.png";
import BidCalculateIcon from "@/assets/images/Tab/bid-calculate-icon.png";
import BidCalculateIconActive from "@/assets/images/Tab/bid-calculate-icon-active.png";
import BidScenarioIcon from "@/assets/images/Tab/bid-scenario.png";
import BidScenarioIconActive from "@/assets/images/Tab/bid-scenario-active.png";
import { ReactComponent as PencilSvg } from "@/assets/images/mdi-pencil.svg";
import BidInvoiceIconActive from "@/assets/images/Tab/invoice-icon-active.svg";
import ContentLayout from "@/layouts/ContentLayout";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import CommonTab from "@/components/Common/Tab";
import { TabMenu } from "@/types/Shared/tab";
import {
  useReadProjectGroups,
  useUpdateProjectGroups,
} from "@/libs/react-query/hooks/useProjectQuery";
import { useEffect, useRef, useState } from "react";
import HeaderBackButton from "@/components/HeaderBackButton";
import { Skeleton } from "@/components/ui/skeleton";
import { showToast } from "@/utils/toastUtils";

export default function ProjectManagementLayout() {
  return (
    <ContentLayout>
      <Outlet />
    </ContentLayout>
  );
}

export function ProjectGroupsLayout() {
  const { group_id } = useParams();
  const { state } = useLocation();

  const tabData: TabMenu[] = [
    {
      label: "프로젝트 상세",
      path: `/management/projects/${group_id}`,
      icon: BidDetailIcon,
      activeIcon: BidDetailIconActive,
    },
    // {
    //   label: "투찰 가격 산출",
    //   path: `/management/projects/${group_id}/calculate`,
    //   icon: BidCalculateIcon,
    //   activeIcon: BidCalculateIconActive,
    // },
    {
      label: "산출내역서",
      path: `/management/projects/${group_id}/estimates`,
      icon: BidEstimateIcon,
      activeIcon: BidEstimateIconActive,
    },
    {
      label: "시나리오 분석",
      path: `/management/projects/${group_id}/scenario`,
      icon: BidScenarioIcon,
      activeIcon: BidScenarioIconActive,
    },
  ];
  return (
    <>
      <HeaderBackButton />
      <EditProjectGroupTitle />
      <div>
        <CommonTab variants="button" data={tabData} state={state} />
        <Outlet />
      </div>
    </>
  );
}

export function EditProjectGroupTitle() {
  const { group_id = "" } = useParams();

  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const { data, isLoading, isError } = useReadProjectGroups(group_id);
  const { mutate: updateProjectGroup } = useUpdateProjectGroups(group_id);

  const project_group_title = data?.project_group_title ?? "";

  useEffect(() => {
    if (project_group_title) {
      setInputValue(project_group_title);
    }
  }, [project_group_title]);

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
    }
  }, [isEditing]);

  const handleEditClick = () => setIsEditing(true);

  const handleCancel = () => {
    setIsEditing(false);
    setInputValue(project_group_title);
  };

  const handleSave = () => {
    if (!inputValue.trim() || inputValue === project_group_title) {
      setIsEditing(false);
      return;
    }

    updateProjectGroup(
      { title: inputValue },
      {
        onSuccess: () => {
          showToast({
            message: "프로젝트 그룹 이름이 수정되었습니다.",
          });
          setIsEditing(false);
        },
      }
    );
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };

  if (isError) return null;

  if (isLoading) {
    return (
      <div className="inline-block">
        <Skeleton className="bg-white w-60 h-7" />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      {isEditing ? (
        <>
          <input
            ref={inputRef}
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            className="min-w-fit py-1 px-4 border border-dark-red rounded-sm text-[18px] text-gray-A font-bold"
          />
          <div className="flex items-center gap-2">
            <Button
              variant="cancel"
              size="sm"
              className="text-[10px]"
              onClick={handleCancel}
            >
              취소
            </Button>
            <Button
              variant="confirm"
              size="sm"
              className="text-[10px]"
              onClick={handleSave}
            >
              수정
            </Button>
          </div>
        </>
      ) : (
        <>
          <span className="text-lg font-bold text-gray-A">
            {project_group_title}
          </span>
          <PencilSvg
            className="size-4 cursor-pointer"
            onClick={handleEditClick}
          />
        </>
      )}
    </div>
  );
}
